export class ListFindingExclusionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "findingExclusions",
            "baseName": "findingExclusions",
            "type": "Array<FindingExclusion>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListFindingExclusionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
